/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import {
  FetchCalendarGoogle,
  DeleteCalendarGoogle,
  RelationCalendarGoogle,
  PutCalendarGoogle,
  CleaningCalendarGoogle
} from '@/infrastructure/network/Monitaro/requests/calendar_google'

export default class CalendarGoogle extends MonitaroGatewayBase {
  async FetchCalendarGoogle() {
    const { calendars } = await this.apiClient.request(new FetchCalendarGoogle())
    return calendars
  }

  async DeleteCalendarGoogle() {
    const { result } = await this.apiClient.request(new DeleteCalendarGoogle())
    return result
  }

  async RelationCalendarGoogle(id: string) {
    return await this.apiClient.request(new RelationCalendarGoogle(id))
  }

  async PutCalendarGoogle(id: string, checked: boolean) {
    const { result } = await this.apiClient.request(new PutCalendarGoogle(id, { checked }))
    return result
  }

  async CleaningCalendarGoogle(id: string) {
    const { result } = await this.apiClient.request(new CleaningCalendarGoogle(id))
    return result
  }
}
